import React, { Component } from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import requester from "../../../lib/requester";
import { Loader } from "react-overlay-loader";
import "react-overlay-loader/styles.css";
import moment from "moment";
import _ from "lodash";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import XLSX from "xlsx";

class ReportSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedInvoiceNo: "",
      selectedCustomer: "",
      selectedDocNo: "",
      orgName: "",
      dataTable: [],
      lovBranch: [],
      loading: false,
      status: "",
      Param_SubmitFrom: new Date(),
      Param_SubmitTo: new Date(),
    };
  }

  componentDidMount = () => {
    this.getBranch();
  };

  getBranch = () => {
    let url = "/api/traces/v1/general/list-cabang";
    requester.getTraces(url, {
      success: function (response) {
        this.setState({ lovBranch: response.data.data });
      }.bind(this),
      error: function (e) {
        console.log(e);
      },
    });
  };

  handleSearch = () => {
    let url = "/api/collect/v1/report-document/doc-monitoring-group";
    let param = {
      startDate: this.state.Param_SubmitFrom,
      endDate: this.state.Param_SubmitTo,
      docNumber: this.state.selectedDocNo,
      orgName: this.state.orgName,
      status: this.state.status,
    };
    this.setState({ loading: true });
    requester.postCollect(url, param, {
      success: function (response) {
        let { data } = response.data;
        this.setState({ loading: false, dataTable: data });
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false });
        console.log(e.message);
      }.bind(this),
    });
  };
 
  handleExport = () => {
    let data = this.state.dataTable;
    if (data.length > 0) {
      this.setState({ loading: true });
      const workBook = XLSX.utils.book_new(); // create a new blank book
      const workSheet = XLSX.utils.json_to_sheet(data, { raw: false });
      XLSX.utils.book_append_sheet(workBook, workSheet, "Sheet1"); // add the worksheet to the book
      XLSX.writeFile(workBook, "REPORT_SUMMARY_DOC_MONITORING_" + moment(new Date()).format("DDMMYYYY") + ".xlsx");
      this.setState({ loading: false });
    } else {
      alert("No Data to be Exported !");
    }

    // let url = '/api/collect/v1/report-document/doc-monitoring-group'
    // let param = {
    //   startDate: this.state.Param_SubmitFrom,
    //   endDate: this.state.Param_SubmitTo,
    //   docNumber: this.state.selectedDocNo,
    //   orgName: this.state.orgName,
    //   orgSource: this.state.orgSource,
    //   status: this.state.status
    // }
    // this.setState({ loading: true })
    // requester.postCollect(url, param, {
    //   success: function (response) {
    //     let { data } = response.data
    //     const workBook = XLSX.utils.book_new(); // create a new blank book
    //     const workSheet = XLSX.utils.json_to_sheet(data, { raw: false });
    //     XLSX.utils.book_append_sheet(workBook, workSheet, "Sheet1"); // add the worksheet to the book
    //     XLSX.writeFile(
    //       workBook,
    //       "REPORT_SUMMARY_DOC_MONITORING_" + moment(new Date()).format('DDMMYYYY') + ".xlsx"
    //     );
    //     this.setState({ dataTable: data, loading: false})
    //   }.bind(this),
    //   error: function (e) {
    //     this.setState({ loading: false })
    //     console.log(e.message)
    //   }.bind(this)
    // })
  };

  handleChangeInput = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    this.setState({ [name]: value });
  };

  renderFilter = () => {
    return (
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-md-3">
                  <label>Sender</label>
                  <select className="form-control" name="orgSource" onChange={this.handleChangeInput.bind(this)}>
                    <option value="">ALL</option>
                    {this.state.lovBranch.map((item, index) => (
                      <option value={item.org_name} key={index}>
                        {item.org_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-3">
                  <label>Destination</label>
                  <select className="form-control" name="orgName" onChange={this.handleChangeInput.bind(this)}>
                    <option value="">ALL</option>
                    {this.state.lovBranch.map((item, index) => (
                      <option value={item.org_name} key={index}>
                        {item.org_name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-md-3">
                  <label>Document No</label>
                  <input type="text" className="form-control" value={this.state.selectedDocNo} name="selectedDocNo" onChange={this.handleChangeInput.bind(this)} />
                </div>
                <div className="col-md-3">
                  <div className="">
                    <label>Submitted (From)</label>
                    <div className="customDatePickerWidth">
                      <DatePicker placeholder="Submitted Date from" selected={this.state.Param_SubmitFrom} dateFormat="d-MMM-yyyy" className="form-control myDatePicker" popperPlacement="bottom-end" onChange={this.handleSubmittedDateFrom} />
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="">
                    <label>Submitted (To)</label>
                    <div className="customDatePickerWidth">
                      <DatePicker placeholder="Submitted Date from" selected={this.state.Param_SubmitTo} dateFormat="d-MMM-yyyy" className="form-control myDatePicker" popperPlacement="bottom-end" onChange={this.handleSubmittedDateTo} />
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <label>Status</label>
                  <select className="form-control" onChange={this.handleChangeInput.bind(this)} name="status">
                    <option value="">- Select Status -</option>
                    <option value={"WAITING"}>WAITING</option>
                    <option value={"RECEIVED"}>RECEIVED</option>
                    <option value={"SENT"}>SENT</option>
                    <option value={"DELETE"}>DELETE</option>
                  </select>
                </div>
              </div>
              <div className="row">
                <div className="col-md-3">
                  <div className="">
                    <label>&nbsp;</label>
                    <button className="btn btn-primary btn-block" onClick={this.handleSearch.bind(this)}>
                      <i className="fa fa-search"></i> Search
                    </button>
                  </div>
                </div>
                <div className="col-md-3">
                  <label>&nbsp;</label>
                  <button className="btn btn-success btn-block" onClick={this.handleExport.bind(this)}>
                    <i className="fa fa-file-excel"></i> Export
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderTable = () => {
    const data = {
      columns: [
        {
          Header: "SENDER",
          accessor: "SENDER",
          filterable: true,
        },
        {
          Header: "DESTINATION",
          accessor: "DESTINATION",
          filterable: true,
        },
        {
          Header: "DOC NO",
          accessor: "DOC_NO",
          filterable: true,
        },
        {
          Header: "DOC DATE",
          accessor: "DOC_DATE",
          filterable: true,
          Cell: (row) => (
            <span>
              <span>{row.value !== null && row.value !== "" && row.value !== "null" ? moment(new Date(row.value)).format("DD-MMM-YYYY") : ""}</span>
            </span>
          ),
        },
        {
          Header: "TOTAL DOC",
          accessor: "TOTAL_INVOICE",
          filterable: true,
        },
        {
          Header: "AWB DATE",
          accessor: "AWB_DATE",
          filterable: true,
          Cell: (row) => (
            <span>
              <span>{row.value !== null && row.value !== "" && row.value !== "null" ? moment(new Date(row.value)).format("DD-MMM-YYYY") : ""}</span>
            </span>
          ),
        },
        {
          Header: "AWB NO",
          accessor: "AWB_NO",
          filterable: true,
        },
        {
          Header: "SUBMITTED BY",
          accessor: "SUBMITTED_BY",
          filterable: true,
        },
        {
          Header: "SUBMITTED DATE",
          accessor: "SUBMITTED_DATE",
          filterable: true,
          Cell: (row) => (
            <span>
              <span>{row.value !== null && row.value !== "" && row.value !== "null" ? moment(new Date(row.value)).format("DD-MMM-YYYY") : ""}</span>
            </span>
          ),
        },
        {
          Header: "STATUS",
          accessor: "STATUS",
          filterable: true,
        },
        {
          Header: "SENT BY",
          accessor: "SENT_BY",
          filterable: true,
        },
        {
          Header: "RECEIVE BY",
          accessor: "RECEIVED_BY",
          filterable: true,
        },
        {
          Header: "RECEIVE DATE",
          accessor: "RECEIVED_DATE",
          filterable: true,
          Cell: (row) => (
            <span>
              <span>{row.value !== null && row.value !== "" && row.value !== "null" ? moment(new Date(row.value)).format("DD-MMM-YYYY") : ""}</span>
            </span>
          ),
        },
      ],
      rows: this.state.dataTable,
    };
    return (
      <div className="row">
        <div className="col-12 text-right">
          <div className="col-12 mt-2 px-0">
            <ReactTable
              className="fullWidth"
              data={data.rows}
              columns={data.columns}
              defaultPageSize={10}
              defaultFilterMethod={(filter, row, column) => {
                let columnes = row[filter.id];
                return columnes ? columnes.toLowerCase().includes(filter.value.toLowerCase()) : "";
              }}
            />
          </div>
        </div>
      </div>
    );
  };

  handleSubmittedDateFrom = (date) => {
    this.setState({ Param_SubmitFrom: date });
  };

  handleSubmittedDateTo = (date) => {
    this.setState({ Param_SubmitTo: date });
  };

  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12 col-sx-12">
                <div className="card card-info">
                  {/* <div className='card-header'>Report Balance Claim</div> */}
                  <div className="card-body">
                    {this.renderFilter()}
                    <div className="clearfix">&nbsp;</div>
                    <div className="row">
                      <div className="col-lg-12">{this.renderTable()}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Loader fullPage loading={this.state.loading} />
      </div>
    );
  }
}

export default ReportSummary;
